import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { Config } from '../config/env.config';
import { contentHeaders, contentXWWWHeaders } from 'common/headers';
import { BaseHttpService } from '../base/_base-http.service';
import { AuthService } from '../auth/auth.service';
import { Process } from './process';
import { receiversStub } from './exportGenerateStub';
import { getRandomInt } from 'utils/utils';
import {startWith, switchMap, catchError, map} from 'rxjs/operators';
import {of, interval} from 'rxjs';


@Injectable()
export class ProcessService extends BaseHttpService {

    private processes: Array<Process>;

    pollProcesses(brandId: string) {
      return interval(15000)
        .pipe(
            startWith(0),
            switchMap(() => this.http.get(`${Config.API}/processes/${brandId}`))
        );

     }

    getProcesses(brandId: string): Observable<any> {
        if (this.processes) {
            return of(this.processes);
        } else {
            return this.http.get(`${Config.API}/processes/${brandId}`)

                .pipe(map( res => _.map(res, (process: any) => {
                  process.current = 0;
                  return process;
                })),
                catchError(this.handleError.bind(this)));
        }
    }

    postStatusUpdateItemsImmediate(status: string, brandId: string, ids: any[], processId: string, filter: any= null): Observable<any> {

        let status_id = 0;
        status_id = this.getStatusId(status);

        const body = JSON.stringify({status: status_id, ids: ids, processId: processId, filter: filter});
        return this.http.post(`${Config.API}/items/${brandId}/statuses`, body, {headers: contentHeaders})
        ;
    }

    postStatusUpdateAllItemsImmediate(
      status: string, brandId: string, ids: any[], filter: any = null, isSelectAll: boolean
    ): Observable<any> {
        let status_id = 0;
        status_id = this.getStatusId(status);

        const body = JSON.stringify({
          status: status_id,
          ids: isSelectAll ? null : ids,
          search: isSelectAll ? filter : null,
          select_all_results: isSelectAll
        });
        return this.http.post(`${Config.API}/items/${brandId}/statuses`, body, {headers: contentHeaders});
    }

    postStatusUpdateItems(status: string, brandId: string, ids: any[], filter: any= null): Observable<any> {

      let status_id = 0;
      status_id = this.getStatusId(status);

      const bodyIds = JSON.stringify(ids);

      filter = filter ? '&' + filter : '';
      const body =
        'ids=' + encodeURIComponent(bodyIds) +
        '&status=' + status_id +
        filter;
        return this.http.post(`${Config.API}/items/${brandId}/status-update`, body, {headers: contentXWWWHeaders});
    }


    postStatusUpdateAssets(status: string, brandId: string, ids: any[], filter: any= null): Observable<any> {

        let status_id = 0;
        // Leaving this as a switch if we ever add additional status for Assets
        status_id = this.getStatusId(status);

        const body = JSON.stringify({status: status_id, ids: ids, filter: filter});
        return this.http.post(`${Config.API}/assets/${brandId}/status-update`, body, {headers: contentHeaders});
    }

    postImportReviewItems(brandId: string, ids: any[], filter: any= null): Observable<any> {
      const list = _.get(filter, 'list', '');
      const body = JSON.stringify({ids: ids, filter: filter, list: list});
      return this.http.post(`${Config.API}/items/${brandId}/imported/accept`, body, {headers: contentHeaders});
    }

    postImportReviewApps(brandId: string, ids: any[], filter: any= null): Observable<any> {
      const list = _.get(filter, 'list', '');
      const body = JSON.stringify({ids: ids, filter: filter,  list: list});
      return this.http.post(`${Config.API}/apps/${brandId}/imported/accept`, body, {headers: contentHeaders});
    }


    getReceivers(brandId: string): Observable<any> {
       return this.http.get(`${Config.API}/receivers/${brandId}`)
         .pipe(catchError(this.handleError.bind(this)));
    }

    postExportItems(
      brandId: string,
      exportTypeIds: Array<string|number>,
      ids: Array<string|number>,
      status: string,
      filter: any = null,
      priceSheets: Array<string>,
      priceSheetCurrencies: Array<string>,
      userFileName: string,
      state: string,
      customFields?: Array<string|number>,
      columns?: Array<any>,
      runNow?: boolean,
      schedule?: string,
      scheduleName?: string,
    ): Observable<any> {

      const bodyExportTypeIds = JSON.stringify(exportTypeIds);
      const bodyIds = JSON.stringify(ids);
      const bodyPriceSheets = JSON.stringify(priceSheets);
      const bodyPriceSheetCurrencies = JSON.stringify(priceSheetCurrencies);
      const bodyCustomFields = JSON.stringify(customFields);
      const bodyColumns = JSON.stringify(columns);

      filter = filter ? '&' + filter : '';
      let body =
        'ids=' + encodeURIComponent(bodyIds) +
        '&exportTypeIds=' + encodeURIComponent(bodyExportTypeIds) +
        '&priceSheets=' + encodeURIComponent(bodyPriceSheets) +
        '&priceSheetCurrencies=' + encodeURIComponent(bodyPriceSheetCurrencies) +
        '&customFields=' + encodeURIComponent(bodyCustomFields) +
        '&userFileName=' + encodeURIComponent(userFileName) +
        '&columns=' + encodeURIComponent(bodyColumns) +
        filter;

        if (schedule) {
          body +=
            '&schedule[frequency]=' + encodeURIComponent(schedule) +
            '&schedule[name]=' + encodeURIComponent(scheduleName) +
            '&schedule[runNow]=' + (runNow ? '1' : '0');
        }

      return this.http.post(`${Config.API}/export-generate/${brandId}/${state}`, body, {headers: contentXWWWHeaders});
    }

    postExportItemsValid(brandId: string, ids: Array<string|number>, status: string, filter: any = null, state: string): Observable<any> {

      const bodyIds = JSON.stringify(ids);

      filter = filter ? '&' + filter : '';
      const body =
        'ids=' + encodeURIComponent(bodyIds) +
        filter;

      return this.http.post(`${Config.API}/export-valid/${brandId}/${state}`, body, {headers: contentXWWWHeaders});
    }

    postItemsValid(brandId: string, ids: Array<string|number>, status: string, filter: any = null, state: string): Observable<any> {

      const bodyIds = JSON.stringify(ids);

      filter = filter ? '&' + filter : '';
      const body =
        'ids=' + encodeURIComponent(bodyIds) +
        filter;

      return this.http.post(`${Config.API}/items-valid/${brandId}/${state}`, body, {headers: contentXWWWHeaders});
    }


    postExportReceiverItems(
      brandId: string,
      ids: any[],
      status: string,
      filter: any = null,
      priceSheets: string[],
      priceSheetCurrencies: string[],
      receiverIds: string[],
      userFileName: string,
      state: string,
      customFields: Array<string|number>,
      runNow?: boolean,
      schedule?: string,
      scheduleName?: string
    ): Observable<any> {

      const bodyIds = JSON.stringify(ids);
      const bodyPriceSheets = JSON.stringify(priceSheets);
      const bodyPriceSheetCurrencies = JSON.stringify(priceSheetCurrencies);
      const bodyReceiverIds = JSON.stringify(receiverIds);
      const bodyCustomFields = JSON.stringify(customFields);

      filter = filter ? '&' + filter : '';
      let body =
        'ids=' + encodeURIComponent(bodyIds) +
        '&priceSheets=' + encodeURIComponent(bodyPriceSheets) +
        '&priceSheetCurrencies=' + encodeURIComponent(bodyPriceSheetCurrencies) +
        '&receiverIds=' + encodeURIComponent(bodyReceiverIds) +
        '&customFields=' + encodeURIComponent(bodyCustomFields) +
        '&userFileName=' + encodeURIComponent(userFileName) +
        filter;

        if (schedule) {
          body +=
            '&schedule[frequency]=' + encodeURIComponent(schedule) +
            '&schedule[name]=' + encodeURIComponent(scheduleName) +
            '&schedule[runNow]=' + (runNow ? '1' : '0');
        }


       return this.http.post(
         `${Config.API}/export-generate/${brandId}/${state}`,
         body,
         {headers: contentXWWWHeaders}
       );
    }

    deleteArchivedItems(brandId: string, ids: Array<string>, filter: any = null, isSelectAll: boolean): Observable<any> {
      const body = JSON.stringify({
        ids: isSelectAll ? [] : ids,
        search: isSelectAll ? filter : null,
        select_all_results: isSelectAll
      });
      return this.delete(
        `${Config.API}/items/${brandId}/`,
        body,
        {headers: contentHeaders}
      )

          .pipe(catchError(this.handleError.bind(this)));
    }

    getQueueProcess(brandId: string, processId: number|string): Observable<any> {
      return this.http.get(`${Config.API}/process/${brandId}/${processId}`)
          .pipe(catchError(this.handleError.bind(this)));
    }

    private exportItem(exportType: number, brandId: string, ids: any[], filter: any= null): Observable<any> {
      const body = JSON.stringify({ids: ids, export_type: exportType, filter: filter});
      return this.http.post(`${Config.API}/export/${brandId}`, body, {headers: contentHeaders});
    }

    private getStatusId(status: string) {
      let status_id = 0;
      switch (status.toLocaleLowerCase()) {
        case 'draft':
          status_id = 0;
          break;
        case 'review':
          status_id = 1;
          break;
        case 'approve':
          status_id = 2;
          break;
        case 'publish':
          status_id = 8;
          break;
        case 'unpublish':
          status_id = 10;
          break;
        case 'archive':
          status_id = 3;
          break;
      }
      return status_id;
    }
}
